import MultiSelectValidation from './MultiSelectValidation';

export default MultiSelectValidation;
